export default __webpack_public_path__ + "static/media/bg_petra.656a0c41.png";